import Modal from 'component/hoc/modal/Modal';
import React, { useEffect, useState } from 'react';
import styles from '../OptionsSelector.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';

const OptionsSelectorModal = ({
  showModal,
  onClose,
  options,
  page_TextColor,
  handleAddOption,
  handleRemoveOption,
  maxOptions,
  errorMessage,
  setErrorMessage,
}) => {
  const [inputValue, setInputValue] = useState('');

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && inputValue.trim() !== '') {
      if (!maxOptions || options.length < maxOptions) {
        handleAddOption(inputValue.trim());
        setInputValue('');
      } else {
        setErrorMessage(`You can't add more than ${maxOptions} options`);
      }
    }
  };
  useEffect(() => {
    setTimeout(() => {
      setErrorMessage(null);
    }, 1000);
  }, [errorMessage]);
  return (
    <Modal title="View Options" isOpen={showModal} onClose={onClose}>
      <div className={styles['modal-cont']}>
        <div className={styles['input-container']}>
          <div className={styles['input-wrapper']}>
            <div className={styles['img-input-cont']}>
              <input
                className={styles.input}
                placeholder="Add Option"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={handleKeyDown}
              />
            </div>

            <SvgWithBranding
              type="plusSVG"
              color={page_TextColor}
              onClick={() => {
                if (
                  inputValue.trim() !== '' &&
                  (!maxOptions || options.length < maxOptions)
                ) {
                  handleAddOption(inputValue.trim());
                  setInputValue('');
                }
              }}
            />
          </div>
        </div>
        {errorMessage && <p className="error-message"> {errorMessage}</p>}
        <div className={styles.optionsCont}>
          {options.length > 0
            ? options.map(({ optionValue }, index) => (
                <div key={index} className={styles.option}>
                  <p>{optionValue}</p>
                  <SvgWithBranding
                    type="plusSVG"
                    className={styles.icon}
                    color="white"
                    onClick={() => handleRemoveOption(optionValue)}
                  />
                </div>
              ))
            : ''}
        </div>
      </div>
    </Modal>
  );
};

export default OptionsSelectorModal;
